import { BrandMark } from '@/shared/components/BrandMark';

/**
 * Which programme this product belongs to, at the right end of every shell's
 * top bar — the same line, and the same spade, the RAISE sites carry:
 * modernization-cli's site header as of 0b7543f1,
 * https://assets.engine.capgemini.com/local-assets/ernd-eastern-europe-gec/rnd-hub/modernization-cli/-/blob/0b7543f1/.claude/site-templates/index.html#L33
 *
 * The spade comes from `BrandMark`, not the sites' PNG: it is the brand kit's
 * own vector, and it follows the theme. Blue on light, white on dark — the two
 * colourways the kit allows (FD-18); the dark theme's primary is the light
 * accent blue, which is not one of them, so dark asks for the foreground.
 *
 * The words go below `sm`, as they do on the sites: a narrow bar needs its
 * room for the controls, and the spade alone still says whose this is — so the
 * spade carries its own accessible name, "Capgemini", rather than a loose
 * screen-reader-only word beside it.
 */
export function RaiseMark() {
  return (
    <span className="ms-auto flex shrink-0 items-center gap-2 whitespace-nowrap">
      <span className="text-foreground hidden text-xs font-semibold sm:inline short-touch:hidden!">
        part of RAISE for Software Product X
      </span>
      <span role="img" aria-label="Capgemini">
        <BrandMark
          variant="spade"
          className="text-primary dark:text-foreground size-9"
        />
      </span>
    </span>
  );
}
